import { Component, Vue} from 'nuxt-property-decorator';

@Component
export default class AboutPageComponent extends Vue {

    public fetch({ redirect , route }) {
        if (route.path === '/about/') {
            redirect('/about/company/');
        }
    }
}
